import styles from './Switch.module.css';

interface SwitchProps {
  /** Id of the element that names the switch. */
  labelledBy: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/** On/off toggle (a pressed button), e.g. Left-handed. */
export function Switch({ labelledBy, checked, onChange }: SwitchProps) {
  return (
    <button
      type="button"
      className={styles.switch}
      aria-labelledby={labelledBy}
      aria-pressed={checked}
      onClick={() => {
        onChange(!checked);
      }}
    >
      <span className={styles.track}>
        <span className={styles.knob} />
      </span>
    </button>
  );
}
